import React from 'react';
import { useState } from 'react';
import { Box, Button, Card, Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';

const Container = styled(Flex)`
  /* gap: 40px;
  @media screen and (max-width: 52em) {
    display: none;
  } */
`;
const ContainerMobile = styled(Flex)`
  @media screen and (min-width: 52em) {
    display: none;
  }
`;

const CheckMarkText = ({ children }) => {
  return (
    <Flex mb={'14px'}>
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
        <path
          d="M3.44103 10.0135C3.66802 10.0135 3.84749 9.90225 3.97404 9.6855L8.96164 0.96675C9.05667 0.79675 9.099 0.668 9.099 0.533C9.099 0.21075 8.90354 0 8.61328 0C8.40746 0 8.28609 0.076 8.15931 0.29875L3.41987 8.6835L0.960409 5.10925C0.828677 4.90425 0.701898 4.82225 0.506664 4.82225C0.210997 4.82225 0 5.05075 0 5.373C0 5.50775 0.0526931 5.66 0.153125 5.8005L2.89204 9.674C3.05552 9.9025 3.21405 10.014 3.44081 10.014"
          fill="#0E6823"
        />
      </svg>
      <Flex ml={'6px'} flex={1}>
        {children}
      </Flex>
    </Flex>
  );
};

const WithKitCard = () => {
  return (
    <Card style={{ width: '292px', maxWidth: '292px', borderRadius: '20px', position: 'relative', overflow: 'hidden', padding: '13px 23px 27px 23px' }}>
      <svg style={{ position: 'absolute', right: 0, top: 0 }} xmlns="http://www.w3.org/2000/svg" width="181" height="167" viewBox="0 0 181 167" fill="none">
        <path
          opacity="0.2"
          d="M119.899 -55.1346C145.086 -48.2019 167.287 -36.6287 186.244 -18.8374C191.826 -13.4823 197.675 -8.41148 203.769 -3.64433C227.162 14.239 232.508 38.7175 228.38 65.6787C224.009 94.2242 211.931 119.638 190.515 139.5C170.143 158.391 145.038 167.779 117.468 166.539C105.904 166.018 93.9311 159.915 83.345 154.146C59.7392 141.285 39.6635 123.769 21.0169 104.351C2.96495 85.5444 -2.11206 63.3115 0.744007 38.8137C3.65302 13.8423 13.1393 -9.06149 27.1164 -29.7597C40.6979 -49.8713 61.0022 -58.2412 84.9081 -57.8383C96.5806 -57.6448 108.237 -56.0803 119.899 -55.1346Z"
          fill="#7992B3"
          fill-opacity="0.5"
        />
      </svg>
      <Flex flexDirection={'column'} style={{ zIndex: 1 }}>
        <Text style={{ fontSize: '12px', fontWeight: 600, textAlign: 'center', lineHeight: '25px', marginBottom: '12px' }}>MOST POPULAR</Text>
        <Heading style={{ fontSize: '18px', lineHeight: '30px' }} textAlign={'center'}>
          🔬 With a GI Test kit
        </Heading>
        <Text style={{ fontSize: '12px', fontWeight: 400, textAlign: 'center', lineHeight: '17px', marginTop: '10px', width: '150px', alignSelf: 'center', justifySelf: 'center' }}>
          Best for patients who need a full gut analysis.
        </Text>
        <Flex mt={3} flexDirection={'column'} style={{ width: '100%', backgroundColor: '#FFF9F7', borderRadius: '10px', alignSelf: 'center', padding: '12px 14px', position: 'relative', zIndex: 1 }}>
          <Text style={{ fontSize: '14px', fontWeight: 600, textAlign: 'center' }}>
            Starting at $143
            <span style={{ fontSize: '10px', fontWeight: 300 }}>/month*</span>
          </Text>
        </Flex>
        <Flex alignItems={'center'} justifyContent={'center'}>
          <Button
            mt={3}
            variant={'primary'}
            style={{
              alignSelf: 'center',
              fontWeight: 300,
              padding: '8px 14px',
            }}
          >
            Get Started
          </Button>
        </Flex>
        <Text style={{ fontSize: '12px', fontWeight: 700 }} mt={3} mb={'14px'}>
          Includes:
        </Text>
        <CheckMarkText>
          <Text style={{ fontSize: '12px', fontWeight: 400, lineHeight: '15px' }}>
            At-home GI microbiome test from <span style={{ fontWeight: 600 }}>Tiny Health</span> ($249 value)
          </Text>
        </CheckMarkText>
        <CheckMarkText>
          <Text style={{ fontSize: '12px', fontWeight: 400, lineHeight: '15px' }}>1 nutritionist visit per month</Text>
        </CheckMarkText>
        <CheckMarkText>
          <Text style={{ fontSize: '12px', fontWeight: 400, lineHeight: '15px' }}>Personalized gut-focused treatment plan</Text>
        </CheckMarkText>
        <CheckMarkText>
          <Text style={{ fontSize: '12px', fontWeight: 400, lineHeight: '15px' }}>Nutrition and supplement guidance</Text>
        </CheckMarkText>
        <CheckMarkText>
          <Text style={{ fontSize: '12px', fontWeight: 400, lineHeight: '15px' }}>Unlimited messaging with your nutritionist</Text>
        </CheckMarkText>
        <Text style={{ fontSize: '10px', textAlign: 'center' }} mt={'14px'} mb={'14px'}>
          * With a 9-month plan paid upfront in full.
        </Text>
      </Flex>
    </Card>
  );
};

const WithoutKitCard = () => {
  return (
    <Card style={{ width: '292px', maxWidth: '292px', borderRadius: '20px', position: 'relative', overflow: 'hidden', padding: '13px 23px 27px 23px', display: 'flex', flexDirection: 'column' }}>
      <svg style={{ position: 'absolute', top: 0 }} xmlns="http://www.w3.org/2000/svg" width="209" height="80" viewBox="0 0 209 80" fill="none">
        <path
          opacity="0.2"
          d="M98.6437 -142.135C123.831 -135.202 146.032 -123.629 164.989 -105.838C170.57 -100.483 176.42 -95.4117 182.514 -90.6446C205.907 -72.7612 211.253 -48.2827 207.125 -21.3216C202.754 7.22398 190.676 32.638 169.26 52.4998C148.888 71.3912 123.783 80.7791 96.2132 79.5386C84.6485 79.0181 72.6761 72.9143 62.09 67.1459C38.4842 54.2849 18.4085 36.7686 -0.238134 17.3507C-18.2901 -1.45581 -23.3671 -23.6887 -20.511 -48.1865C-17.602 -73.158 -8.11574 -96.0617 5.86137 -116.76C19.4429 -136.872 39.7472 -145.241 63.6531 -144.839C75.3256 -144.645 86.9815 -143.081 98.6437 -142.135Z"
          fill="#E7F0FF"
        />
      </svg>
      <Flex flexDirection={'column'} style={{ zIndex: 1 }}>
        <Heading style={{ fontSize: '18px', lineHeight: '30px', marginTop: '10px', marginBottom: '10px' }} textAlign={'center'}>
          📄 Without a GI Test kit
        </Heading>
        <Text style={{ fontSize: '12px', fontWeight: 400, textAlign: 'center', lineHeight: '17px', marginTop: '10px', width: '219px', alignSelf: 'center', justifySelf: 'center' }}>
          Best for patients who already have GI-MAP, Genova, or similar test results.
        </Text>
        <Flex
          mt={3}
          flexDirection={'column'}
          style={{ width: 'fit-content', backgroundColor: '#FFF9F7', borderRadius: '10px', alignSelf: 'center', padding: '12px 14px', position: 'relative', zIndex: 1 }}
        >
          <Text style={{ fontSize: '14px', fontWeight: 600, textAlign: 'center' }}>
            Starting at $110
            <span style={{ fontSize: '10px', fontWeight: 300 }}>/month*</span>
          </Text>
        </Flex>
        <Flex alignItems={'center'} justifyContent={'center'}>
          <Button
            mt={3}
            variant={'primary'}
            style={{
              alignSelf: 'center',
              fontWeight: 300,
              padding: '8px 14px',
            }}
          >
            Get Started
          </Button>
        </Flex>
        <Text style={{ fontSize: '12px', fontWeight: 700 }} mt={3} mb={'14px'}>
          Includes:
        </Text>
        <CheckMarkText>
          <Text style={{ fontSize: '12px', fontWeight: 400, lineHeight: '15px' }}>In-depth review of your GI test (from within the last 12 months)</Text>
        </CheckMarkText>
        <CheckMarkText>
          <Text style={{ fontSize: '12px', fontWeight: 400, lineHeight: '15px' }}>1 nutritionist visit per month</Text>
        </CheckMarkText>
        <CheckMarkText>
          <Text style={{ fontSize: '12px', fontWeight: 400, lineHeight: '15px' }}>Personalized gut-focused treatment plan</Text>
        </CheckMarkText>
        <CheckMarkText>
          <Text style={{ fontSize: '12px', fontWeight: 400, lineHeight: '15px' }}>Nutrition and supplement guidance</Text>
        </CheckMarkText>
        <CheckMarkText>
          <Text style={{ fontSize: '12px', fontWeight: 400, lineHeight: '15px' }}>Unlimited messaging with your nutritionist</Text>
        </CheckMarkText>
        <Text style={{ fontSize: '10px', textAlign: 'center' }} mt={'14px'} mb={'14px'}>
          * With a 9-month plan paid upfront in full.
        </Text>
      </Flex>
    </Card>
  );
};

const PriceCard = ({onClick}) => {
  return (
    <Card style={{ width: '352px', maxWidth: '352px', borderRadius: '20px', position: 'relative', overflow: 'hidden', padding: '13px 23px 27px 23px', display: 'flex', flexDirection: 'column' }}>
      <svg style={{ position: 'absolute', top: 0 }} xmlns="http://www.w3.org/2000/svg" width="209" height="80" viewBox="0 0 209 80" fill="none">
        <path
          opacity="0.2"
          d="M98.6437 -142.135C123.831 -135.202 146.032 -123.629 164.989 -105.838C170.57 -100.483 176.42 -95.4117 182.514 -90.6446C205.907 -72.7612 211.253 -48.2827 207.125 -21.3216C202.754 7.22398 190.676 32.638 169.26 52.4998C148.888 71.3912 123.783 80.7791 96.2132 79.5386C84.6485 79.0181 72.6761 72.9143 62.09 67.1459C38.4842 54.2849 18.4085 36.7686 -0.238134 17.3507C-18.2901 -1.45581 -23.3671 -23.6887 -20.511 -48.1865C-17.602 -73.158 -8.11574 -96.0617 5.86137 -116.76C19.4429 -136.872 39.7472 -145.241 63.6531 -144.839C75.3256 -144.645 86.9815 -143.081 98.6437 -142.135Z"
          fill="#E7F0FF"
        />
      </svg>
      <Flex flexDirection={'column'} style={{ zIndex: 1 }}>
        <Heading style={{ fontSize: '20px', lineHeight: '30px', marginTop: '10px', marginBottom: '10px' }} textAlign={'center'}>
          Gut Reset Program
        </Heading>
        <Text style={{  fontWeight: 400, textAlign: 'center', lineHeight: '17px', marginTop: '10px', width: '300px', alignSelf: 'center', justifySelf: 'center' }}>
          A comprehensive gut health program designed to reset inflammation, improve digestion, and support your thyroid and hormone balance.
        </Text>
        <Flex
          mt={3}
          flexDirection={'column'}
          style={{ width: 'fit-content', backgroundColor: '#FFF9F7', borderRadius: '10px', alignSelf: 'center', padding: '12px 14px', position: 'relative', zIndex: 1 }}
        >
          <Text style={{  fontWeight: 600, textAlign: 'center' }}>
            Starting at $110
            <span style={{ fontSize: '14px', fontWeight: 300 }}>/month*</span>
          </Text>
        </Flex>
        <Flex alignItems={'center'} justifyContent={'center'}>
          <Button
            mt={3}
            onClick={()=>{onClick()}}
            variant={'primary'}
            style={{
              alignSelf: 'center',
              fontWeight: 300,
              padding: '8px 14px',
            }}
          >
            Get Started
          </Button>
        </Flex>
        <Text style={{ fontSize: '14px', fontWeight: 700 }} mt={3} mb={'14px'}>
          Includes:
        </Text>
        <CheckMarkText>
          <Text style={{ fontSize: '14px', fontWeight: 400, lineHeight: '15px' }}>In-depth review of your GI test (from within the last 12 months)</Text>
        </CheckMarkText>
        <CheckMarkText>
          <Text style={{ fontSize: '14px', fontWeight: 400, lineHeight: '15px' }}>1 nutritionist visit per month</Text>
        </CheckMarkText>
        <CheckMarkText>
          <Text style={{ fontSize: '14px', fontWeight: 400, lineHeight: '15px' }}>Personalized gut-focused treatment plan</Text>
        </CheckMarkText>
        <CheckMarkText>
          <Text style={{ fontSize: '14px', fontWeight: 400, lineHeight: '15px' }}>Nutrition and supplement guidance</Text>
        </CheckMarkText>
        <CheckMarkText>
          <Text style={{ fontSize: '14px', fontWeight: 400, lineHeight: '15px' }}>Unlimited messaging with your nutritionist</Text>
        </CheckMarkText>
        <Text style={{ fontSize: '12px', textAlign: 'center' }} mt={'14px'} mb={'14px'}>
          * With a 9-month plan paid upfront in full.
        </Text>
      </Flex>
    </Card>
  );
};

const MobilePricing = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  return (
    <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
      <Flex alignItems={'center'} justifyContent={'center'} mb={4}>
        <Box
          style={{
            padding: '2px 12px',
            color: selectedTab === 0 ? 'white' : '#344f79',
            background: selectedTab === 0 ? '#344f79' : 'transparent',
            border: '1px solid #344f79',
            borderRadius: '6px 0 0 6px',
            cursor: 'pointer',
          }}
          onClick={() => setSelectedTab(0)}
          flex={1}
        >
          With a kit
        </Box>
        <Box
          style={{
            padding: '2px 12px',
            color: selectedTab === 1 ? 'white' : '#344f79',
            background: selectedTab === 1 ? '#344f79' : 'transparent',
            border: '1px solid #344f79',
            borderRadius: '0 6px 6px 0',
            cursor: 'pointer',
            minWidth: 'fit-content',
          }}
          onClick={() => setSelectedTab(1)}
          flex={1}
        >
          Without a kit
        </Box>
      </Flex>

      {selectedTab === 0 && <WithKitCard />}

      {selectedTab === 1 && <WithoutKitCard />}
    </Flex>
  );
};

export const PricingCards = ({onClick}) => {
  return (
    <>
      <Container>
        {/* <WithKitCard /> */}
        <PriceCard onClick={onClick}/>
      </Container>
      {/* 
      <ContainerMobile>
        <MobilePricing />
      </ContainerMobile> */}
    </>
  );
};
